import React from "react";
import Title from "../Components/Elements/Title";
import Text from "../Components/Elements/Text";
import MainContainer from "../Components/Elements/MainContainer";
import menuJson from '../Data/menu.json';
import childrenMenuJson from '../Data/childrenMenu.json';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Dish } from "../Models/Dish";

interface Props {
    useHelm?: boolean;
}

const MenuItem = ({ dish }: { dish: Dish }) => {
    return (
        <div className="mb-6">
            <Text className="font-bold">{dish.name} {dish.vegan && <span className="text-green-700">(Vegan)</span>} {dish.vegetarian && <span className="text-green-700">(Vegetarian)</span>}</Text>
            <Text>{dish.description}</Text>
            {dish.allergens && <Text className="text-sm">Allergens: {dish.allergens.join(", ")}</Text>}
        </div>
    )
}

const Menu = ({ useHelm = false }: Props) => {
    return (
        <MainContainer>
            {
                useHelm && (
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>H&R Wedding | Menu</title>
                    </Helmet>
                )
            }
            <Title size="3">Menu</Title>
            <Text>Below is the menu for the event. Kindly make your selections <Link to="/app/rsvp" className="text-blue-600 hover:underline visited:text-purple-600">
  here
</Link>.</Text>
            <div className="pb-4 border-b-2">
                <div>
                    <Title size="2" className="pt-3">Starters</Title>
                    <div>
                        { menuJson.starters.map((starter : Dish) => (
                            MenuItem({dish: starter})
                        ))}
                    </div>
                </div>
                <div>
                    <Title size="2" className="pt-3">Mains</Title>
                    <div>
                        { menuJson.mains.map((main : Dish) => (
                            MenuItem({dish: main})
                        ))}
                    </div>
                </div>
                <div>
                    <Title size="2" className="pt-3">Desserts</Title>
                    <div>
                        { menuJson.desserts.map((dessert : Dish) => (
                            MenuItem({dish: dessert})
                        ))}
                    </div>
                </div>
                <Text className="pt-4">
                    <Link
                        to="/app/rsvp"
                        className="bg-blue-500 hover:bg-blue-700 font font-lora text-white font-bold py-2 px-4 rounded my-2 inline-block text-center"
                    >
                        Make your selections
                    </Link>
                </Text>
            </div>
            <div>
                <Title size="3" className="pt-6">Children&apos;s Menu</Title>
                <div>
                    <Title size="2" className="pt-3">Starters</Title>
                    <div>
                        { childrenMenuJson.starters.map((starter : Dish) => (
                            MenuItem({dish: starter})
                        ))}
                    </div>
                </div>
                <div>
                    <Title size="2" className="pt-3">Mains</Title>
                    <div>
                        { childrenMenuJson.mains.map((main : Dish) => (
                            MenuItem({dish: main})
                        ))}
                    </div>
                </div>
                <div>
                    <Title size="2" className="pt-3">Desserts</Title>
                    <div>
                        { childrenMenuJson.desserts.map((dessert : Dish) => (
                            MenuItem({dish: dessert})
                        ))}
                    </div>
                </div>
            </div>

            <Text className="pt-4">
                <Link
                    to="/app/rsvp"
                    className="bg-blue-500 hover:bg-blue-700 font font-lora text-white font-bold py-2 px-4 rounded my-2 inline-block text-center"
                >
                    Make your selections
                </Link>
            </Text>
            { useHelm && <Text className="pt-4">
                <Link
                    to="/app"
                    className="bg-blue-500 hover:bg-blue-700 font font-lora text-white font-bold py-2 px-4 rounded my-2 inline-block text-center"
                >
                    Home
                </Link>
            </Text>}
        </MainContainer>
    )
}

export default Menu;